import {
  faAddressCard,
  faAt,
  faHouseUser,
  faPhone,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '@mui/material'
import React from 'react'

function ExpediteurBloc({ data }) {
  return (
    <>
      <h5>Expediteur</h5>
      <div className="card">
        <h5 className="fullname">
          <FontAwesomeIcon
            icon={faAddressCard}
            style={{ marginRight: '1rem' }}
          />
          {`${data?.expediteur.civilite} ${data?.expediteur.prenom} ${data?.expediteur.nom}`}
        </h5>
        <p>
          <FontAwesomeIcon icon={faHouseUser} style={{ marginRight: '1rem' }} />
          {`${data?.expediteur.adresse},`} <br />
          {`${data?.expediteur.codePostal} ${data?.expediteur.ville}`}
        </p>
        <Box
          style={{
            marginTop: '0.8rem',
            marginBottom: '0.8rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <p>
            <FontAwesomeIcon icon={faPhone} style={{ marginRight: '1rem' }} />
            {data?.expediteur.telephone}
          </p>
          <p>
            <FontAwesomeIcon icon={faAt} style={{ marginRight: '1rem' }} />
            {data?.expediteur.email}
          </p>
        </Box>
      </div>
    </>
  )
}

export default ExpediteurBloc
